module.exports = __webpack_public_path__ + "img/image-map-geocoding-717f2c5c.png";